import { DEFAULT_ZOOM } from "./mapConstants";

export interface MapViewOptions {
  satellite?: boolean;
  defaultZoom?: number;
  minZoom?: number;
  maxZoom?: number;
  zoomControl?: boolean;
}

export { DEFAULT_MAP_VIEW_OPTIONS } from "./mapConstants";

/** Neutral → google.maps.MapOptions (matches the old DEFAULT_MAP_OPTIONS). */
export const toGoogleMapOptions = (o: MapViewOptions): google.maps.MapOptions => ({
  disableDefaultUI: true,
  zoomControl: o.zoomControl ?? true,
  mapTypeId: o.satellite === false ? "roadmap" : "satellite",
  zoom: o.defaultZoom ?? DEFAULT_ZOOM,
  ...(o.minZoom != null ? { minZoom: o.minZoom } : {}),
  maxZoom: o.maxZoom ?? 40,
});

/** Neutral → MapLibre init params. MapLibre's hard max zoom is 24. */
export const toLibreOptions = (o: MapViewOptions) => ({
  zoom: o.defaultZoom ?? DEFAULT_ZOOM,
  minZoom: o.minZoom ?? 0,
  maxZoom: Math.min(o.maxZoom ?? 24, 24),
  satellite: o.satellite !== false,
  zoomControl: o.zoomControl ?? true,
});
